import { Component, Input, OnInit } from '@angular/core';
import { Sccs1ConversationType } from '../../../../samwebDescription/samwin/Sccs1ConversationType';
import _ from 'lodash';
import { faAlarmClock } from '@fortawesome/pro-duotone-svg-icons';
import { IciFlags } from '../../../../../generated/signalR/ici-flags';
import { IciVisualizeType } from '../../../../samwebDescription/samwin/IciVisualizeType';
import { IciDirection } from 'src/app/samwebDescription/samwin/IciDirection';

@Component({
   selector: 'samweb-ici-type',
   templateUrl: './ici-type.component.html',
   styleUrls: ['./ici-type.component.scss'],
})
export class IciTypeComponent implements OnInit {
   public readonly solidFlag = faAlarmClock;

   constructor() {
      this.ConversationType = Sccs1ConversationType.Unknown;
   }

   public ConversationType: Sccs1ConversationType;
   public ConversationTypeClass: string;
   public IciDirection: IciDirection[];
   public IciVisualization: IciVisualizeType[];

   @Input()
   set conversationTypeAsString(name: string) {
      this.ConversationType = Sccs1ConversationType.valueByName(name);
      if (_.isNil(this.ConversationType)) {
         this.ConversationType = Sccs1ConversationType.Unknown;
      }
   }

   @Input()
   set conversationTypeAsSamwinValue(samwinValue: number) {
      this.ConversationType = Sccs1ConversationType.valueBySamwinValue(samwinValue);
      if (_.isNil(this.ConversationType)) {
         this.ConversationType = Sccs1ConversationType.Unknown;
      }
   }

   @Input()
   set ici(ici: IciFlags) {
      this.IciVisualization = IciVisualizeType.getAllIciVisualizationTypesForIci(ici);
      this.ConversationTypeClass = this.IciVisualization.length > 0 ? this.IciVisualization[0].styleClass : '';
   }

   @Input()
   set iciDirectionType(ici: IciFlags) {
      this.IciDirection = IciDirection.getIciDirectionTypesForIci(ici);
   }

   ngOnInit() {}
}
